import { render } from "./PerformanceReport.vue?vue&type=template&id=5aae388e&scoped=true"
import script from "./PerformanceReport.vue?vue&type=script&lang=js"
export * from "./PerformanceReport.vue?vue&type=script&lang=js"

import "./PerformanceReport.vue?vue&type=style&index=0&id=5aae388e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/sharesight_partner_app/sharesight_partner_app/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5aae388e"]])

export default __exports__